module.exports = __webpack_public_path__ + "img/noresult.f6470677.png";